import { render, staticRenderFns } from "./pid-unit.vue?vue&type=template&id=3f642cf8&scoped=true"
import script from "./pid-unit.vue?vue&type=script&lang=js"
export * from "./pid-unit.vue?vue&type=script&lang=js"
import style0 from "./pid-unit.vue?vue&type=style&index=0&id=3f642cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f642cf8",
  null
  
)

export default component.exports